import React from "react";
import ReactQuill from "react-quill";
import {
  CloseOutlined,
  FileImageOutlined,
  InboxOutlined,
  PaperClipOutlined,
  PlusOutlined,
} from "@ant-design/icons";
// import { UserOutlined } from "@ant-design/icons";
import {
  Checkbox,
  DatePicker,
  Input,
  InputNumber,
  Radio,
  Select,
  Switch,
  TimePicker,
  Tooltip,
  Transfer,
  Upload,
} from "antd";
import locale from "antd/es/date-picker/locale/vi_VN";
import { RedTrashIcon } from "assets/icons";
import _ from "lodash";
import moment from "moment";
import { editorModules } from "utils/editorConfig";

// import { uploadImage } from "src/app/apis/Common";
import AppButton from "components/button";
import ColorPicker from "components/inputs/colorPicker";
import SelectMultiple from "components/inputs/selectMultiple";
import SelectSearchCustomer from "components/inputs/selectSearchCustomer";
import SelectSearchMultiple from "components/inputs/selectSearchMultiple";
import AppTimePicker from "components/inputs/timePicker";

import "moment/locale/vi";

import styles from "./styles.module.scss";

const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;
const TextArea = Input.TextArea;

/**
 *
 * @param type {("file" | "image" | "image-multiple" | "transfer-multiple" | "clock" | "hour" | "minute" | "second" |
 *   "date" | "datetime" | "date-range" | "month" | "year" |
 *              "select-search" | "select-boolean" | "select" | "multiple" | "number" | "currency" |
 *              "online-search" | "search" | "text" | "textarea" | "position" | "product" | "product-rent" | "customer"
 *   | "contract")}
 * @param data {{
 *     placeholder: string,
 *     value: any,
 *     disabled: boolean,
 *     disabledDate: (function | Array)
 *     options: Array,
 *     selectKeyLabel: string,
 *     selectKeyValue: string,
 *     noAllowClear: boolean,
 *     config: Object,
 *     keySearch: string,
 *     apiSearch: string
 * }}
 * @param actions {{
 *     onChange: function
 * }}
 * @returns {*}
 */

const getInput = (type, data = {}, actions = {}) => {
  const { placeholder, value, disabled, icon, size, readOnly } = data;
  // label
  const { disabledDate } = data;
  const { options, noAllowClear, tagRender } = data;
  let { selectKeyLabel, selectKeyValue } = data;
  selectKeyValue = selectKeyValue ?? "id";
  selectKeyLabel = selectKeyLabel ?? "name";

  const { render } = data;

  const { config = {}, key } = data;

  const { onChange } = actions;

  const filterOption = (input, option) => {
    if (input && input.startsWith("04")) {
      return (option?.children ?? "")
        .toLowerCase()
        .includes(input.replace("04", "614"));
    } else {
      return (option?.children ?? "")
        .toLowerCase()
        .includes(input.toLowerCase());
    }
  };

  // const uploadImageCallBack = async file => {
  //   if (file && file.name) {
  //     let fileUrl;
  //     const resultUrl = await uploadImage(file);
  //     if (resultUrl && resultUrl.data && resultUrl.data.fileUrls) {
  //       fileUrl = resultUrl.data.fileUrls[0];
  //     }
  //     return {
  //       status: 200,
  //       success: true,
  //       data: { link: fileUrl },
  //     };
  //   } else {
  //     return null;
  //   }
  // };

  switch (type) {
    case "file":
      return (
        <div className="upload-container">
          <Upload
            beforeUpload={file => {
              onChange(file);
              return false;
            }}
            multiple={false}
            showUploadList={false}
            onRemove={() => onChange(null)}
          >
            <AppButton label={"upload"} color="grey" />
          </Upload>
          {typeof value === "string" && value && (
            <div className="preview">
              <PaperClipOutlined />
              &nbsp;<span>{value}</span>
            </div>
          )}
          {typeof value === "object" && value && (
            <div className="preview">
              <PaperClipOutlined />
              &nbsp;<span>{value.name}</span>
            </div>
          )}
          {value && (
            <span className="remove-btn" onClick={() => onChange(null)}>
              <CloseOutlined />
              <span>삭제</span>
            </span>
          )}
        </div>
      );
    case "file-avatar":
      return (
        <div className="upload-container">
          <Upload
            name="avatar"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            multiple={false}
            beforeUpload={file => {
              onChange(file);
              return false;
            }}
          >
            <div>
              <PlusOutlined />
              <div
                style={{
                  marginTop: 8,
                }}
              >
                Upload
              </div>
            </div>
          </Upload>
        </div>
      );
    case "file-dragger":
      return (
        <div className="upload-container">
          <Upload.Dragger
            beforeUpload={file => {
              onChange(file);
              return false;
            }}
            multiple={false}
            showUploadList={false}
            onRemove={() => onChange(null)}
            accept={config?.accept}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">{config?.uploadText}</p>
            <p className="ant-upload-hint">{config?.uploadHint}.</p>
          </Upload.Dragger>
          {config?.description && (
            <p style={{ color: "red", textAlign: "center", width: "100%" }}>
              {config?.description}
            </p>
          )}
          {typeof value === "string" && value && (
            <div className="preview">
              <PaperClipOutlined />
              &nbsp;<span>{value}</span>
            </div>
          )}
          {typeof value === "object" && value && (
            <div className={styles.previewDragger}>
              <span>
                <PaperClipOutlined />
                &nbsp;<span>{value.name}</span>
              </span>
              <Tooltip title={"remove file"}>
                <span
                  className="remove-btn"
                  style={{ color: "red" }}
                  onClick={() => onChange(null)}
                >
                  <RedTrashIcon />
                </span>
              </Tooltip>
            </div>
          )}
        </div>
      );
    case "transfer-multiple":
      return (
        <Transfer
          titles={["Chưa chọn", "Đã chọn"]}
          showSearch
          showSelectAll
          dataSource={options}
          targetKeys={value}
          render={render ? render : item => item.title}
          onChange={next => {
            onChange(next);
          }}
          locale={{
            selectAll: "Chọn tất cả các trang",
            remove: "Xóa",
            removeAll: "Xóa tất cả",
            removeCurrent: "Xóa trang này",
            selectCurrent: "Chọn trang này",
            selectInvert: "Đảo chọn trang này",
          }}
          pagination={{
            pageSize: 100,
            // showSizeChanger: false
          }}
        />
      );
    case "clock":
    case "minute":
    case "second":
      return (
        <TimePicker
          onChange={value => {
            if (config.getObject) {
              onChange(value);
            } else {
              onChange(
                value ? value.format(config.format ?? "HH:mm:ss") : value
              );
            }
          }}
          placeholder={placeholder}
          value={value ? moment(value, config.format ?? "HH:mm:ss") : null}
          name={key}
          disabled={disabled}
          format={config.format ?? "HH:mm:ss"}
          locale={locale}
        />
      );
    case "hour":
      return (
        <AppTimePicker
          onChange={value => {
            onChange(
              value ? moment(value).format(config.format ?? "HH:mm:ss") : value
            );
          }}
          placeholder={placeholder}
          value={value ? moment(value, config.format ?? "HH:mm:ss") : "00:00"}
          name={key}
          disabled={disabled}
        />
      );
    case "hour-minutes":
      return (
        <TimePicker
          minuteStep={config?.minuteStep}
          format={config?.format}
          showNow={config?.showNow}
          onChange={value => {
            onChange(
              value ? moment(value).format(config.format ?? "HH:mm") : value
            );
          }}
          // value={value ? value : "00:00"}
          style={config?.style}
          disabled={disabled}
        />
      );
    case "date":
    case "month":
    case "year":
    case "date-range": {
      const CustomPicker = {
        date: DatePicker,
        month: DatePicker.MonthPicker,
        year: DatePicker.YearPicker,
        datetime: DatePicker,
        "date-range": DatePicker.RangePicker,
      }[type];

      const dataFormat = {
        datetime: "YYYY-MM-DD HH:mm:ss",
        date: "YYYY-MM-DD",
        month: "YYYY-MM",
        year: "YYYY",
        "date-range": "YYYY-MM-DD",
      }[type];
      const displayFormat = {
        datetime: "YYYY-MM-DD HH:mm:ss",
        date: "YYYY-MM-DD",
        month: "YYYY-MM",
        year: "YYYY",
        "date-range": "YYYY-MM-DD",
      }[type];

      let valueFormat = null;
      if (value) {
        if (type === "date-range") {
          valueFormat = value.map(dt =>
            moment(dt, config.format ?? dataFormat)
          );
        } else {
          valueFormat = moment(value, config.format ?? dataFormat);
        }
      }

      return (
        <CustomPicker
          onChange={value => {
            if (config.getObject) {
              onChange(value);
            } else {
              if (type === "date-range") {
                onChange(
                  value
                    ? value.map(dt => dt.format(config.format ?? dataFormat))
                    : value
                );
              } else {
                onChange(
                  value ? value.format(config.format ?? dataFormat) : value
                );
              }
            }
          }}
          placeholder={placeholder}
          value={valueFormat}
          format={displayFormat}
          name={key}
          disabled={disabled}
          disabledDate={current => {
            if (_.isFunction(disabledDate)) {
              return disabledDate(current);
            }
            if (_.isArray(disabledDate)) {
              return (
                current && disabledDate.includes(current.format("YYYY-MM-DD"))
              );
            }
            return false;
          }}
          locale={locale}
          allowClear={!noAllowClear}
        />
      );
    }
    case "datetime": {
      let valueDate = null;
      let valueTime = null;
      let momentValue = null;
      momentValue = moment(value === "" ? undefined : value);
      if (!value || value === "") {
        momentValue = momentValue.hours(0).minutes(0);
      }
      valueDate = momentValue.format("YYYY-MM-DD");
      valueTime = momentValue.format("HH:mm");

      const hoursValue = valueTime ? momentValue.hours() : 0;
      const minutesValue = valueTime ? momentValue.minutes() : 0;

      return (
        <div styles={{ display: "flex" }}>
          <DatePicker
            onChange={value => {
              if (config.getObject || !value) {
                onChange(undefined);
              } else {
                const params = moment(value)
                  .hours(hoursValue)
                  .minutes(minutesValue)
                  .format(config.format ?? "YYYY-MM-DD HH:mm:ss");
                onChange(params);
              }
            }}
            placeholder={"yyyy-MM-dd"}
            value={
              !value || value === ""
                ? undefined
                : moment(valueDate, "YYYY-MM-DD")
            }
            format={"YYYY-MM-DD"}
            name={key}
            disabled={disabled}
            locale={locale}
            allowClear={!noAllowClear}
          />
          <AppTimePicker
            onChange={time => {
              const momentTime = moment(time);
              const params = moment(valueDate ? valueDate : new Date())
                .hours(momentTime.hours())
                .minutes(momentTime.minutes())
                .format(config.format ?? "YYYY-MM-DD HH:mm:ss");
              onChange(params);
            }}
            placeholder={"hh:mm"}
            value={value ? moment(valueTime, "HH:mm") : undefined}
            name={key}
            disabled={disabled}
            style={{
              width: 200,
              marginLeft: 10,
            }}
          />
        </div>
      );
    }
    case "select-search":
    case "select":
    case "select-boolean":
    case "multiple":
      return (
        <Select
          showSearch={type === "select-search"}
          allowClear={!noAllowClear}
          value={value}
          defaultValue={value ? value : null}
          onChange={value => {
            if (config.getObject) {
              onChange(options.find(dt => dt[selectKeyValue] === value));
            } else {
              onChange(value);
            }
          }}
          placeholder={placeholder}
          disabled={config?.disabled}
          loading={config?.loading}
          filterOption={filterOption}
          onPopupScroll={event =>
            config?.handleScroll && config?.handleScroll(event)
          }
          onSearch={event =>
            config?.handleSearchKey && config?.handleSearchKey(event)
          }
          style={{
            width: config?.width,
            padding: "0",
            textAlign: "start",
          }}
        >
          {options.map((option, index) => (
            <Select.Option
              key={index.toString() + option[selectKeyLabel]}
              value={option.id}
              disabled={option.disabled}
            >
              {option.name}
            </Select.Option>
          ))}
        </Select>
      );
    case "tags":
      return (
        <SelectMultiple
          type={type}
          options={options}
          value={value}
          noAllowClear={noAllowClear}
          selectKeyValue={selectKeyValue}
          config={config}
          placeholder={placeholder}
          tagRender={tagRender}
          selectKeyLabel={selectKeyLabel}
          onChange={onChange}
        />
      );
    case "tags-search":
      return (
        <SelectSearchMultiple
          type={"select-search"}
          options={options}
          value={value}
          noAllowClear={noAllowClear}
          selectKeyValue={selectKeyValue}
          config={config}
          placeholder={placeholder}
          tagRender={tagRender}
          selectKeyLabel={selectKeyLabel}
          onChange={onChange}
        />
      );
    case "tags-search-customer":
      return (
        <SelectSearchCustomer
          type={"select-search"}
          options={options}
          value={value}
          noAllowClear={noAllowClear}
          selectKeyValue={selectKeyValue}
          config={config}
          placeholder={placeholder}
          tagRender={tagRender}
          selectKeyLabel={selectKeyLabel}
          onChange={onChange}
        />
      );
    case "tags-search-single":
      return (
        <Select
          showSearch={type === "select-search"}
          allowClear={!noAllowClear}
          value={value}
          defaultValue={value ? value : null}
          onChange={value => {
            if (config.getObject) {
              onChange(options.find(dt => dt[selectKeyValue] === value));
            } else {
              onChange(value);
            }
          }}
          placeholder={placeholder}
          disabled={config?.disabled}
          filterOption={filterOption}
          style={{
            width: config?.width,
            padding: "0",
            textAlign: "start",
          }}
        >
          {options.map((option, index) => (
            <Select.Option
              key={index.toString() + option[selectKeyLabel]}
              value={option.id}
              disabled={option.disabled}
            >
              {option.name}
            </Select.Option>
          ))}
        </Select>
      );
    case "number":
      return (
        <InputNumber
          onChange={value => {
            onChange(value);
          }}
          prefix={icon ? icon : ""}
          min={config?.min}
          max={config?.max}
          placeholder={placeholder}
          value={value}
          name={key}
          controls={config?.controls}
          size={config?.size}
          autoComplete="off"
          maxLength={50}
          disabled={config?.disabled}
          style={config?.style}
          addonAfter={config?.addonAfter}
          addonBefore={config?.addonBefore}
          formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          parser={value => value.replace(/\$\s?|(,*)/g, "")}
        />
      );
    case "currency":
      return (
        <Input
          type="search"
          onChange={event => {
            let value = event.target.value;
            value = value.replace(/\D+/g, "");
            onChange(value);
          }}
          placeholder={placeholder}
          name={key}
          autoComplete="off"
          maxLength={50}
          disabled={disabled}
        />
      );
    case "checkbox":
      return (
        <Checkbox
          onChange={event => {
            const value = event.target.checked;
            onChange(value);
          }}
          checked={value}
        >
          {/* {label} */}
        </Checkbox>
      );
    case "checkbox-group":
      return (
        <CheckboxGroup
          onChange={list => {
            onChange(list);
          }}
          value={value}
          options={options}
          name={key}
          disabled={config?.disabled}
        />
      );
    case "radio":
      return (
        <RadioGroup
          onChange={event => {
            onChange(event.target.value);
          }}
          value={value}
          options={options}
          name={key}
        />
      );
    case "textarea":
      return (
        <TextArea
          onChange={event => {
            const value = event.target.value;
            onChange(value);
          }}
          placeholder={placeholder}
          value={value}
          name={key}
          autoComplete="off"
          maxLength={
            type === "textarea"
              ? config?.maxLength
                ? config?.maxLength
                : 1000
              : 50
          }
          disabled={disabled}
          rows={4}
          autoSize={{ minRows: 3 }}
          showCount={config.showCount}
          count={{
            max: config.maxLength,
          }}
        />
      );
    case "image":
      return (
        <div className={styles.wrapImage}>
          {value ? (
            <img alt={key} src={value} className={styles.image} />
          ) : (
            <FileImageOutlined className={styles.image} />
          )}
        </div>
      );
    case "color": {
      return (
        <ColorPicker
          value={value}
          onChange={onChange}
          placeholder={placeholder}
        />
      );
    }
    case "password": {
      return (
        <Input.Password
          onChange={event => {
            const value = event.target.value;
            onChange(value);
          }}
          placeholder={placeholder}
          value={value}
          name={key}
          autoComplete="off"
          type={type ?? "search"}
          prefix={icon ? icon : ""}
          maxLength={
            config?.maxLength
              ? config?.maxLength
              : type === "textarea"
              ? 1000
              : 255
          }
          disabled={disabled}
        />
      );
    }
    case "switch":
      return <Switch onChange={onChange} checked={value} disabled={disabled} />;
    case "editor":
      return (
        <ReactQuill
          placeholder={placeholder}
          readOnly={disabled}
          theme={"snow"}
          defaultValue={""}
          onChange={val => {
            onChange && onChange(val);
          }}
          modules={editorModules()}
          value={value}
          preserveWhitespace={true}
          className={`${disabled && "hiddenToolbar"} ${
            config?.customClassName
          }`}
          style={
            disabled ? { ...config?.disabledStyle } : { ...config?.stytle }
          }
        />
      );
    case "search":
    default: {
      if (!readOnly) {
        return (
          <Input
            onChange={event => {
              const value = event.target.value;
              onChange(value);
            }}
            placeholder={placeholder}
            value={value}
            name={key}
            autoComplete="off"
            type={type ?? "search"}
            prefix={icon ? icon : ""}
            size={size ? size : ""}
            maxLength={
              config?.maxLength
                ? config?.maxLength
                : type === "textarea"
                ? 1000
                : 255
            }
            showCount={config.showCount}
            count={{
              max: config.maxLength,
            }}
            disabled={disabled}
          />
        );
      }
    }
  }
};

/**
 *
 * @param type {("file" | "image" | "image-multiple" | "transfer-multiple" | "clock" | "hour" | "minute" | "second" |
 *   "date" | "datetime" | "date-range" | "month" | "year" |
 *              "select-search" | "select-boolean" | "select" | "multiple" | "number" | "currency" |
 *              "online-search" | "search" | "text" | "textarea" | "position" | "product" | "product-rent" | "customer"
 *   | "contract")}
 * @returns {null|string|boolean|*[]|number}
 */
const getDefaultValueInput = type => {
  switch (type) {
    case "select-boolean":
      return true;
    case "online-search":
    case "select":
    case "select-search":
      return undefined;
    case "date":
    case "datetime":
    case "date-range":
    case "month":
    case "year":
    case "clock":
    case "image":
    case "image-multiple":
    case "position":
    case "customer":
    case "product":
    case "product-rent":
    case "contract":
      return null;
    case "multiple":
    case "transfer-multiple":
    case "checkbox-group":
      return [];
    case "number":
    case "currency":
      return 0;
    case "checkbox":
      return false;
    case "search":
    case "text":
    case "textarea":
    default:
      return "";
  }
};

/**
 *
 */

export default {
  getInput,
  getDefaultValueInput,
};

export { getDefaultValueInput, getInput };
